import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, catchError, map } from 'rxjs';
import { HandlerSnackbarService } from 'src/app/services/handler-snackbar.service';
import { IncidentsService } from 'src/app/services/incidents.service';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-incident-info',
  templateUrl: './incident-info.component.html',
  styleUrls: [],
})
export class IncidentInfoComponent implements OnInit {
  incidentId: string | undefined = undefined;
  formData$: Observable<any> | undefined;
  active = 1;
  constructor(
    private readonly modalService: NgbModal,
    private readonly service: IncidentsService,
    private readonly alertService: HandlerSnackbarService,
    private readonly spinnerService: SpinnerService
  ) {}

  ngOnInit(): void {
    if (this.incidentId) {
      this.spinnerService.open();
      this.formData$ = this.service.getIncidents(this.incidentId).pipe(
        catchError((error: HttpErrorResponse) => {
          this.closeModal();
          return this.alertService.handlerErrorSubscribe(error);
        }),
        map((data: any) => {
          this.spinnerService.close();
          return data?.form || {};
        })
      );
    }
  }

  closeModal() {
    this.modalService.dismissAll();
  }
}
